import React from 'react';
const AccordionArrow = () => {
    return (React.createElement("svg", { width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { y: "0.864014", width: "24", height: "24", rx: "12", fill: "#E5E4E4" }),
        React.createElement("g", { clipPath: "url(#clip0_126_6501)" },
            React.createElement("path", { d: "M9 11.364L12 14.364L15 11.364", stroke: "black", strokeWidth: "1.5" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_126_6501" },
                React.createElement("rect", { width: "8", height: "6", fill: "white", transform: "translate(8 9.86401)" })))));
};
export default AccordionArrow;
